import { apis } from '../../../config';
import { api } from '../../../api/api';
import { util } from '../../../api/util/index';
class ConfigSettingApiImpl {
    constructor() {
        this.name = apis.configSettingApiImpl;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
    }
    init() {
        return this.name;
    }
    getCorpCommonRequestParams() {
        const currentUser = this.systemApi.getCurrentUser();
        return {
            domain: currentUser === null || currentUser === void 0 ? void 0 : currentUser.domain,
            uid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        };
    }
    async doDeleteDevice(deviceId, deviceProduct) {
        const deviceInfo = await this.systemApi.getDeviceInfo();
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        const urlKey = isCorpMailMode ? 'corpDeleteDevice' : 'deleteDevice';
        const deviceParams = {
            product: deviceInfo.p,
            deviceId,
            dev_product: deviceProduct || null,
        };
        let requestParams;
        if (isCorpMailMode) {
            const currentUser = this.systemApi.getCurrentUser();
            requestParams = Object.assign(Object.assign(Object.assign({}, deviceParams), this.getCorpCommonRequestParams()), { sid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId });
        }
        else {
            requestParams = deviceParams;
        }
        const { data } = await this.http.post(this.systemApi.getUrl(urlKey), requestParams);
        return Boolean(data === null || data === void 0 ? void 0 : data.result.suc);
    }
    async doGetDeviceList() {
        const deviceInfo = await this.systemApi.getDeviceInfo();
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const urlKey = isCorpMail ? 'corpGetDeviceList' : 'getDeviceList';
        const url = this.systemApi.getUrl(urlKey);
        const params = Object.assign(deviceInfo, {
            lastLoginTime: util.dateFormat(),
            pageSize: '100',
            product: deviceInfo.p === 'web' ? 'sirius' : deviceInfo.p,
        });
        let requestParams;
        if (isCorpMail) {
            const currentUser = this.systemApi.getCurrentUser();
            requestParams = Object.assign(params, { sid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId }, this.getCorpCommonRequestParams());
        }
        else {
            requestParams = params;
        }
        const { data } = await this.http.get(url, requestParams);
        return (data === null || data === void 0 ? void 0 : data.result.suc) ? data.result.loginDeviceList : [];
    }
}
const configSettingApiImpl = new ConfigSettingApiImpl();
api.registerLogicalApi(configSettingApiImpl);
export default configSettingApiImpl;
